export default __webpack_public_path__ + "static/media/60.8a286f29.png";